import { render, staticRenderFns } from "./RedmineIssueViewPage.vue?vue&type=template&id=2c379748&scoped=true"
import script from "./RedmineIssueViewPage.vue?vue&type=script&lang=js"
export * from "./RedmineIssueViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c379748",
  null
  
)

export default component.exports